import React from "react";
import { bool, node, string } from "prop-types";
import Dropdown from "../Dropdown";
import DropdownMenu from "../Dropdown/Menu";

const NavbarDropdownMenu = ({ isList = true, className = "", children, ...props }) => {
	return (
		<Dropdown.Body className={className} {...props}>
			{isList ? <DropdownMenu>{children}</DropdownMenu> : children}
		</Dropdown.Body>
	);
};

NavbarDropdownMenu.propTypes = {
	isList: bool,
	className: string,
	children: node,
};

export default NavbarDropdownMenu;
